/**
 * How the world draws. "classic" is today's look. "stylized" is the look tried out in the Tile Lab:
 * soft painted light without a shadow map, variation on every tile, grass tufts, wind and moving
 * water. Quality tiers keep it smooth on older phones.
 */
export type Look = 'classic' | 'stylized';

export type Quality = 'low' | 'medium' | 'high';

export interface QualitySettings {
  /** The most device pixels the canvas draws per CSS pixel. */
  pixelRatio: number;
  /** Grass tufts on each grass tile (fewer beside a sapling or tree). */
  tufts: number;
  /** Small painted detail on the tile tops: mottled grass, soil crumbs, cracks in stone. */
  detail: boolean;
  /** Ripples, glints and foam move on the water. */
  movingWater: boolean;
  /** Grass, flowers and leaves sway. */
  wind: boolean;
}

export const QUALITY: Readonly<Record<Quality, QualitySettings>> = {
  low: { pixelRatio: 1.5, tufts: 4, detail: false, movingWater: false, wind: true },
  medium: { pixelRatio: 2, tufts: 10, detail: true, movingWater: true, wind: true },
  high: { pixelRatio: 3, tufts: 18, detail: true, movingWater: true, wind: true },
};
